<template>
  <div id="footer">
    <sns></sns>
    <footer id="footer-links" class="footer">
      <div class="columns">
        <div class="column is-4">
          <aside class="menu">
            <p class="menu-label">サイトマップ</p>
            <ul class="menu-list">
              <li>
                <router-link :to="{ name: 'Home'}">トップ</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Materials'}">素材</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Posts'}">投稿</router-link>
              </li>
              <li>
                <router-link :to="{ name: 'Page', params: { pageSlug: 'terms' }}">ご利用について</router-link>
              </li>
              <!-- <li>
                <a href="/">お買い物の流れ</a>
                <ul>
                  <li><a href="/">お買い物の流れ</a></li>
                  <li><a href="/">お買い物の流れ</a></li>
                </ul>
              </li>-->
            </ul>
          </aside>
        </div>

        <div class="column is-4"></div>

        <div class="column is-4">
          <aside class="menu">
            <p class="menu-label">ほかのサイト</p>
            <ul class="menu-list">
              <li>
                <a href="https://lab.nobi.site/" target="_blank">
                  <span class="tag">ブログ</span> のびらぼ
                </a>
              </li>
              <li>
                <a href="https://cowoo.shop/" target="_blank">
                  <span class="tag">総合通販サイト</span>カウー
                </a>
              </li>
              <!-- <li>
                <a href="https://app.nobi.site/" target="_blank">
                  <span class="tag">便利ツール集</span>のびのびツールズ
                </a>
              </li> -->
            </ul>
          </aside>
        </div>
      </div>
    </footer>
    <div id="copyright">
      ©
      <object id="footer-logo" type="image/svg+xml" :data="logo" :alt="title" class="logo"></object>
    </div>

    <div id="page-top" class="toTop anago" v-bind:class="{ 'active': position > 100 }">
      <a href="#" v-scroll-to="'#app'"></a>
    </div>
  </div>
</template>
<script>
import SETTINGS from "../../settings";
// import _ from 'lodash';
import Sns from "../widgets/Sns.vue";

export default {
  data() {
    return {
      logo: this.getImg("img/logo.svg"),
      title: SETTINGS.TITLE,
      position: 0
    };
  },
  created() {},
  mounted() {
    let $ob = $("#footer-logo");
    $ob.on("load", function() {
      let svgDoc = $ob[0].contentDocument;
      if (svgDoc) {
        let $svg = $(svgDoc).find(".cls-1");
        $svg.css("fill", "#fff");
      }
    });
    /**
     * scroll top
     */
    document.onscroll = () => {
      this.position =
        document.documentElement.scrollTop || document.body.scrollTop;
    };
  },
  components: {
    Sns
  }
};
</script>
<style lang="sass">
footer {
  .tag {
    background: transparent;
  }
}
</style>
